import { AppRouter } from './router/appRouter';
import './styles.scss';

export function App() {
	return <AppRouter />;
}
